import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { AppSnackbar, PageTemplateBody, PageTemplateSpinner, Pane, SplitPane } from '@sierralabs/core-ui';
import { TrackChanges } from '@sierralabs/track-changes';
import FormEditPanel from '../editor/FormEditPanel';
import FormConfigure from '../FormConfigure';
import FormProvider from '../FormContext';
import { useApplyFormSchemaDelta } from '../FormSchema.hooks';
import { useFindFormTemplate, useUpdateFormTemplate } from '../FormTemplate.hooks';
const StyledBody = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .navigation-pane {
    flex: 1;
    overflow: auto;
  }
  .form-view-pane {
  }
  .form-config-pane {
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
  }
  .resizer {
    z-index: 1;
  }
`;
export const FormEditorTab = ({ elementPlugins, actionPlugins, transitionConditionPlugins, additionalSectionConfigurations, additionalEventConfigurations, transitionButton, onEdit }) => {
    const { formTemplateId = 0 } = useParams();
    // set up API calls
    const { formTemplate, isLoading } = useFindFormTemplate(+formTemplateId, true);
    const { updatedFormTemplate, isUpdating: isUpdatingFormTemplate, updateError: updateFormTemplateError, updateFormTemplate } = useUpdateFormTemplate((formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.id) || 0);
    const { updatedResult, isUpdating: isUpdatingFormSchema, updateError: updateFormSchemaError, applyFormSchemaDeltas } = useApplyFormSchemaDelta((formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.entity.id) || '');
    // set up state
    const timeoutRef = useRef(0);
    const entitySchemaDeltasRef = useRef([]);
    const [isQueued, setIsQueued] = useState(false);
    const [entitySchema, setEntitySchema] = useState(formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.entity);
    // set entity schema state after form template loads
    useEffect(() => {
        if (formTemplate === null || formTemplate === void 0 ? void 0 : formTemplate.entity) {
            setEntitySchema(formTemplate.entity);
        }
    }, [formTemplate]);
    // update entity schema state after it is saved
    useEffect(() => {
        if (updatedResult) {
            setEntitySchema(entitySchema => {
                if (!entitySchema)
                    return entitySchema;
                const trackChanges = new TrackChanges(entitySchema);
                return trackChanges.final;
            });
        }
    }, [updatedResult]);
    // set progress notification spinner
    useEffect(() => {
        if (updatedResult ||
            updatedFormTemplate ||
            updateFormTemplateError ||
            updateFormSchemaError) {
            setIsQueued(false);
        }
    }, [
        updateFormTemplateError,
        updateFormSchemaError,
        updatedResult,
        updatedFormTemplate
    ]);
    return isLoading || !formTemplate ? (React.createElement(PageTemplateSpinner, null)) : (React.createElement(PageTemplateBody, null,
        React.createElement(FormProvider, { elementPlugins: elementPlugins, actionPlugins: actionPlugins, transitionConditionPlugins: transitionConditionPlugins, additionalSectionConfigurations: additionalSectionConfigurations, additionalEventConfigurations: additionalEventConfigurations, transitionButton: transitionButton, entitySchema: entitySchema, formStateNode: formTemplate.config || {
                name: formTemplate.name.replace(/\//g, ' '),
                states: [
                    {
                        name: 'section-1',
                        meta: {
                            title: 'Section 1',
                            elements: []
                        }
                    }
                ]
            }, onEditSchema: trackChanges => {
                const deltas = trackChanges.commit();
                console.log('onEditSchema deltas to save', deltas);
                entitySchemaDeltasRef.current.push(...deltas);
                applyFormSchemaDeltas(deltas.map(delta => {
                    // make a copy and need to prefix with "config." for formSchema saving
                    delta = Object.assign(Object.assign({}, delta), { path: `config.${delta.path}` });
                    return delta;
                }));
            }, onEdit: trackChanges => {
                const deltas = trackChanges.commit();
                console.log('onEdit deltas to save', deltas);
                setIsQueued(true);
                clearTimeout(timeoutRef.current);
                onEdit === null || onEdit === void 0 ? void 0 : onEdit(trackChanges.final);
                timeoutRef.current = setTimeout(() => {
                    updateFormTemplate({ config: trackChanges.final });
                    // updateFormTemplateConfig(deltaQueue);
                }, 1000);
            } },
            React.createElement(StyledBody, null,
                React.createElement(SplitPane, null,
                    React.createElement(SplitPane, { width: '70%', className: 'form-view-pane' },
                        React.createElement(FormEditPanel, { isSaved: Boolean(updatedFormTemplate), isSaving: isQueued || isUpdatingFormTemplate || isUpdatingFormSchema, saveLabel: isQueued ? 'Changes queued...' : 'Saving...' })),
                    React.createElement(Pane, { className: 'form-config-pane' },
                        React.createElement(FormConfigure, null))))),
        updateFormTemplateError && (React.createElement(AppSnackbar, { open: Boolean(updateFormTemplateError) }, `Error occurred. ${updateFormTemplateError.message}`)),
        updateFormSchemaError && (React.createElement(AppSnackbar, { open: Boolean(updateFormSchemaError) }, `Form Schema update error occurred. ${updateFormSchemaError.message}`))));
};
export default FormEditorTab;
//# sourceMappingURL=FormEditorTab.js.map